export const downloadBlobFile = (blob: Blob, contentDisposition: string, customName?: boolean): void => {
  const blobUrl: string = URL.createObjectURL(blob);
  const link: HTMLAnchorElement = document.createElement('a');

  const filename: string = customName ? contentDisposition : getFileNameFromContentDisposition(contentDisposition);

  link.href = blobUrl;
  link.download = filename;

  document.body.appendChild(link);

  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );

  document.body.removeChild(link);
};

const getFileNameFromContentDisposition = (contentDisposition: string): string => {
  const utf8RegExp: RegExp = /=\?utf-8\?B\?/i;
  const filenameRegex: RegExp = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i;
  const matches: RegExpExecArray | null = filenameRegex.exec(contentDisposition);

  let filename: string = 'file';

  if (matches && matches[1]) {
    filename = matches[1].replace(/['"]/g, '');
  }

  if (utf8RegExp.test(filename)) {
    const base64Filename: string = filename.replace(utf8RegExp, '').replace(/\?=/, '');
    filename = decodeBase64Filename(base64Filename);
  }

  return filename;
};

const decodeBase64Filename = (base64Filename: string): string => {
  try {
    const binaryString = window.atob(base64Filename);
    const bytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));
    return new TextDecoder('utf-8').decode(bytes);
  } catch (error) {
    console.error('Ошибка декодирования имени файла:', error);
    return 'file';
  }
};